// MenuList.js

import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import NavGroup from './NavGroup';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = ({ items }) => {
    const navItems = items.map((item) => {
        if (item.type === 'group') {
            return <NavGroup key={item.id} item={item} />;
        }

        return (
            <Typography key={item.id} variant="h6" color="error" align="center">
                Menu Items Error
            </Typography>
        );
    });

    return <>{navItems}</>;
};

MenuList.propTypes = {
    items: PropTypes.array.isRequired
};

export default MenuList;
